import { Anchor, Flex } from '@mantine/core'
import styles from './LegalLinks.module.css'

export default function LegalLinks({ frontyardUrl }: { isMobile?: boolean; frontyardUrl: string }) {
  return (
    <Flex className={styles.legalLinksContainer} pb={{ base: 'sm', sm: 'xs' }} fz=".75rem" gap="xs">
      <Anchor href={frontyardUrl + '/policies'} target="_blank" className={styles.legalLink}>
        Terms & Policies
      </Anchor>
    </Flex>
  )
}
